// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Classes */
body {
    font-family: 'Figtree', sans-serif !important;
    background: linear-gradient(to right, #f4f4f4, #ffffff);
}

.MuiTabs-indicator {
    background-color: #fafafa !important; /* Yellow */
}

.css-19wsa2m-MuiButtonBase-root-MuiTab-root {
    font-family: 'Figtree', sans-serif !important;
}

.horizontal_fill
{
    width: 100%;
}

.flex_column
{
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
}

.flex_row
{
    display: flex;
    flex-flow: row;
    height: 100%;
    width: 100%;
}

.flex_fill
{
    flex: 1 1;
}

.center
{
    text-align: center;
}

.center_image 
{
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.expander
{
    width: 100%;
    height: 100%;
}

.shrink
{
    margin: 0px;
    border: 0px;
    padding: 0px;
}

.buffer32
{
    padding: 32px;
}

.debug_grid
{
    text-align: center;
    border: 2px black dashed;
}

.graph_title
{
    color: white;
    background-color: rgb(1, 30, 65);
    border: 1px solid gray;
}

/* Homepage & Globals */
#div_menu
{
    position: fixed;
    left: 0px;
    top: 0px;
    height: 64px;
    width: 100%;
    color: white;
    background-color: rgb(1, 30, 65);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

#div_menu img {
    max-width: 150px;
    max-height: 150px;
    object-fit: contain;
}

#tabs {
    width: auto;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
}

#tabs button {
    transition: color 0.3s ease-in-out;
}

#tabs button:hover {
    color: #4c84ae;
}

#div_content
{
    position: fixed;
    left: 0px;
    top: 64px;
    width: 100%;
    height: calc(100% - 96px);
    overflow-y:auto;
    color: black;
    background-color: white;
}

#div_content h2
{
    color: rgb(1, 30, 65);
}

#div_footer
{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40px; 
    color: white;
    background-color: rgb(1, 30, 65);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    opacity: 0;
    z-index: 10;
}

#div_footer.hidden {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
}

#div_footer.visible {
    opacity: 1;
    visibility: visible;
}

#div_footer table {
    width: 100%;
}

#footer_text
{
    margin: 0px;
    text-align: left;
    font-size: 14px; 
}

#div_footer img {
    width: 150px; 
    height: 32px; 
    object-fit: contain;
    display: block;
}

#img_passur
{
    position: fixed;
    bottom: 0px;
    right: 0px;
}

[role="tabpanel"]
{
    width: 100%;
    height: 100%;
}

#div_content > div
{
    padding: 0px;
}

#tabs > div > div > button
{
    color: white;
}

/* Position the arrows properly */
.slider-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: white;
    color: navy;
    border-radius: 50%;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

/* Move arrows to the left and right */
.slider-arrow-left {
    left: -40px; /* Push the left arrow out slightly */
}

.slider-arrow-right {
    right: -40px; /* Push the right arrow out slightly */
}

/*Airport Data*/
.airport_data_container {
    position: relative;
    width: 100%;
    height: 100px;
    overflow: hidden;
    border-radius: 15px 15px 0 0;
}

/* Wrapper for the image */
.airport_data_image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1; /* Behind text */
    border-radius: 15px 15px 0 0;
    overflow: hidden;
}

/* Image with bottom alignment */
.airport_data_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
    filter: brightness(50%);
    border-radius: 15px 15px 0 0;
}

/* Overlay using ::before */
.airport_data_image-wrap::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 102, 204, .6); /* Blue overlay */
    z-index: 2; /* Above the image, behind text */
    border-radius: 15px 15px 0 0;
}

/* Text Content */
.airport_data_text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 3; /* Above overlay */
    width: 80%;
}

.airport_data_text h1 {
    font-weight: bold;
    margin-bottom: 10px;
}

.airport_data_text p {
    font-size: 1.2em;
    max-width: 800px;
    margin: 0 auto;
}

/* Home Welcome Widget */
.home_welcome_container {
    position: relative;
    color: white;
    width: 100%;
    height: 150px; /* Adjust based on how much text you have */
    overflow: hidden; /* Ensures no overflow issues */
}

/* Create a wrapper for the image */
.home_welcome_image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1; /* Behind the text */
}


.home_welcome_container::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3; /* Ensures it sits above the image */
    background: linear-gradient(rgba(1, 30, 65, 0.3), rgba(8, 38, 71, 0.6));
}

.home_welcome_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
    filter: brightness(50%);
}

.home_welcome_text {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 80%;
    z-index: 3;
}

.home_welcome_text h1 {
    color: white;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
}

.home_welcome_text p {
    color: white;
    margin-bottom: 10px;
    text-align: left; /* Align text to the left */
    margin: 0; /* Remove auto-centering */
    flex: 1 1; 
    font-weight: bold;
}

.home_welcome_text button {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

.home_welcome_text button:hover {
    color: white;
}

.home_welcome_text a {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

.home_welcome_text a:hover {
    color: white;
}

/* Tab Link Welcome*/
#widget_tab_link_home_welcome button {
    all: unset;
    color: rgb(0, 102, 204);
    text-decoration: none;
    transition: 0.3s ease-in-out;
    font-weight: bold;
    cursor: pointer;
}

#widget_tab_link_home_welcome button:hover {
    text-decoration: underline;
}

#widget_tab_link_home_welcome h1 {
    color: rgb(1, 30, 65);
}

/* Tab Link Flight Tracker*/
#widget_tab_link_home_flight_link button {
    all: unset;
    color: rgb(0, 102, 204);
    text-decoration: none;
    transition: 0.3s ease-in-out;
    font-weight: bold;
    cursor: pointer;
}

#widget_tab_link_home_flight_link button:hover {
    text-decoration: underline;
}

#widget_tab_link_home_flight_link h1 {
    color: rgb(1, 30, 65);
}

/* Tab Link Complaint*/
#widget_tab_link_home_complaint {
    background-color: rgb(44, 187, 174);
    border-radius: 15px;
    padding: 10px;
}

#widget_tab_link_home_complaint button {
    padding: 3px 6px;
    background-color: #fafafa;
    color: #011E41;
}

#widget_tab_link_home_complaint button:hover {
    background-color: rgb(1, 30, 65);
    border-color: #257dfd;
    color: #4c84ae;
}

#widget_tab_link_home_complaint h1 {
    color: rgb(1, 30, 65);
}

/* FAQ Widget */
#widget_accordion_faq
{
    padding: 32px;
    width: auto;
}

#widget_accordion_faq > div 
{
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
    background-color:  rgb(1, 30, 65);
    border: 1px solid black;
}

#widget_accordion_faq h2 
{
    color: rgb(1, 30, 65);
}

#widget_accordion_faq > div > h3 > div
{
    color: white;
    background-color:  rgb(1, 30, 65);
}

#widget_accordion_faq a {
    all: unset;
    color: #4c84ae; /* Yellow color */
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    display: inline-block; /* Ensures it stays next to the paragraph */
    margin-left: 10px; /* Moves button next to text */
    flex-shrink: 0;
}

#widget_accordion_faq a:hover {
    color: white;
}

#widget_accordion_runways
{
    padding: 32px;
    width: auto;
}

#widget_accordion_runways > div 
{
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
    background-color:  rgb(1, 30, 65);
    border: 1px solid black;
}

#widget_accordion_runways h2 
{
    color: rgb(1, 30, 65);
}

/* Complaint Widget */
#widget_complaint
{
    padding: 32px;
}

#widget_complaint > table
{
    padding: 5px;
    background-color: gainsboro;
    border: 1px solid black;
    border-radius: 12px;
}

#widget_complaint > table > tbody > tr > td
{
    padding: 5px;
}

#textfield_first_name
{
    width: 150px;
}

#textfield_last_name
{
    width: 150px;
}

#textfield_city
{
    width: 150px;
}

#textfield_zip
{
    width: 100px;
}

#textfield_address
{
    width: 250px;
}

#textfield_description
{
    width: 450px;
    height: 150px;
}

#button_save
{
    float: right;
    width: 200px;
}

/* Mobile Complaint Widget */
#widget_mobile_complaint
{
    padding: 16px;
}

#widget_mobile_complaint > table
{
    padding: 5px;
    background-color: gainsboro;
    border: 1px solid black;
    border-radius: 12px;
}

#widget_mobile_complaint > table > tbody > tr > td > h3
{
    margin: 0px;
}

#widget_mobile_complaint > table > tbody > tr > td
{
    padding: 4px;
}

#portal_help h2
{
    color: rgb(1, 30, 65);
}

#runway_config{
    /*overflow: scroll !important;*/
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); 
    border-radius: 15px;
}

#runway_config h2
{
    text-align: center;
    color: rgb(1, 30, 65);
}

#publicvue_pbi {
    border-radius: 15px; 
    overflow: hidden;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); 
}

#graphs_1x {
    border-radius: 0 0 15px 15px; 
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
    color: white; 
}

#graphs_1x h2{
    color: white; 
}

#graphs_2x {
    border-radius: 0 0 15px 15px;  
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); 
    color: white;
}

#graphs_2x h2{
    color: white;
}

#graphs_3x {
    border-radius: 0 0 15px 15px;  
    overflow: visible !important; 
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
    color: white; 
}

#graphs_3x h2{
    color: white; 
}

.date-filter-container {
    background-color: #002147;
    border-radius: 4px;
    padding-top: 20px;
    max-width: 300px;
    color: white;
    font-family: inherit;
  }
  
  .date-filter-label {
    color: white;
    margin-bottom: 8px;
  }
  
  .date-filter-input-label {
    color: white !important;
  }
  
  .date-filter-select {
    color: white;
  }
  
  .date-filter-select .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }
  
  .date-filter-select.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #80bdff;
  }
  
  .date-filter-select:hover .MuiOutlinedInput-notchedOutline {
    border-color: #80bdff;
  }
  
  .date-filter-select .MuiSvgIcon-root {
    color: white;
  }
  
  .date-filter-select .MuiSelect-select {
    color: white;
  }

  
  .date-filter-select .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }

  .slider-widget-filter-bar {
    width: 100%;
    background-color: #002147;
    padding: 12px 40px;
    box-sizing: border-box;
  }

  @media screen and (max-width: 768px) {
  .home_welcome_text h1 {
        font-size: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/config/syd.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,6CAA6C;IAC7C,uDAAuD;AAC3D;;AAEA;IACI,oCAAoC,EAAE,WAAW;AACrD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,SAAO;AACX;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;;IAEI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;AACf;;AAEA,sCAAsC;AACtC;IACI,WAAW,EAAE,qCAAqC;AACtD;;AAEA;IACI,YAAY,EAAE,sCAAsC;AACxD;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,gBAAgB;IAC5B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC,EAAE,iBAAiB;IACpD,UAAU,EAAE,iCAAiC;IAC7C,4BAA4B;AAChC;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAE,kBAAkB;IAC9B,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa,EAAE,2CAA2C;IAC1D,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,oBAAoB;AACpC;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,oCAAoC;IAChD,uEAAuE;AAC3E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,8BAA8B;IAC9B,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB,EAAE,2BAA2B;IAC7C,SAAS,EAAE,0BAA0B;IACrC,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,eAAe;AACf;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,iBAAiB;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,qBAAqB,EAAE,2CAA2C;IAClE,iBAAiB,EAAE,8BAA8B;IACjD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;;IAEI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;;IAEI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;EACA;QACM,eAAe;EACrB;AACF","sourcesContent":["/* Common Classes */\r\nbody {\r\n    font-family: 'Figtree', sans-serif !important;\r\n    background: linear-gradient(to right, #f4f4f4, #ffffff);\r\n}\r\n\r\n.MuiTabs-indicator {\r\n    background-color: #fafafa !important; /* Yellow */\r\n}\r\n\r\n.css-19wsa2m-MuiButtonBase-root-MuiTab-root {\r\n    font-family: 'Figtree', sans-serif !important;\r\n}\r\n\r\n.horizontal_fill\r\n{\r\n    width: 100%;\r\n}\r\n\r\n.flex_column\r\n{\r\n    display: flex;\r\n    flex-flow: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.flex_row\r\n{\r\n    display: flex;\r\n    flex-flow: row;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.flex_fill\r\n{\r\n    flex: 1;\r\n}\r\n\r\n.center\r\n{\r\n    text-align: center;\r\n}\r\n\r\n.center_image \r\n{\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.expander\r\n{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.shrink\r\n{\r\n    margin: 0px;\r\n    border: 0px;\r\n    padding: 0px;\r\n}\r\n\r\n.buffer32\r\n{\r\n    padding: 32px;\r\n}\r\n\r\n.debug_grid\r\n{\r\n    text-align: center;\r\n    border: 2px black dashed;\r\n}\r\n\r\n.graph_title\r\n{\r\n    color: white;\r\n    background-color: rgb(1, 30, 65);\r\n    border: 1px solid gray;\r\n}\r\n\r\n/* Homepage & Globals */\r\n#div_menu\r\n{\r\n    position: fixed;\r\n    left: 0px;\r\n    top: 0px;\r\n    height: 64px;\r\n    width: 100%;\r\n    color: white;\r\n    background-color: rgb(1, 30, 65);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 15px;\r\n}\r\n\r\n#div_menu img {\r\n    max-width: 150px;\r\n    max-height: 150px;\r\n    object-fit: contain;\r\n}\r\n\r\n#tabs {\r\n    width: auto;\r\n    flex-grow: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n#tabs button {\r\n    transition: color 0.3s ease-in-out;\r\n}\r\n\r\n#tabs button:hover {\r\n    color: #4c84ae;\r\n}\r\n\r\n#div_content\r\n{\r\n    position: fixed;\r\n    left: 0px;\r\n    top: 64px;\r\n    width: 100%;\r\n    height: calc(100% - 96px);\r\n    overflow-y:auto;\r\n    color: black;\r\n    background-color: white;\r\n}\r\n\r\n#div_content h2\r\n{\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n#div_footer\r\n{\r\n    position: fixed;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: 40px; \r\n    color: white;\r\n    background-color: rgb(1, 30, 65);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 15px;\r\n    opacity: 0;\r\n    z-index: 10;\r\n}\r\n\r\n#div_footer.hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    visibility: hidden;\r\n}\r\n\r\n#div_footer.visible {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n#div_footer table {\r\n    width: 100%;\r\n}\r\n\r\n#footer_text\r\n{\r\n    margin: 0px;\r\n    text-align: left;\r\n    font-size: 14px; \r\n}\r\n\r\n#div_footer img {\r\n    width: 150px; \r\n    height: 32px; \r\n    object-fit: contain;\r\n    display: block;\r\n}\r\n\r\n#img_passur\r\n{\r\n    position: fixed;\r\n    bottom: 0px;\r\n    right: 0px;\r\n}\r\n\r\n[role=\"tabpanel\"]\r\n{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#div_content > div\r\n{\r\n    padding: 0px;\r\n}\r\n\r\n#tabs > div > div > button\r\n{\r\n    color: white;\r\n}\r\n\r\n/* Position the arrows properly */\r\n.slider-arrow {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background-color: white;\r\n    color: navy;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\r\n    z-index: 10;\r\n}\r\n\r\n/* Move arrows to the left and right */\r\n.slider-arrow-left {\r\n    left: -40px; /* Push the left arrow out slightly */\r\n}\r\n\r\n.slider-arrow-right {\r\n    right: -40px; /* Push the right arrow out slightly */\r\n}\r\n\r\n/*Airport Data*/\r\n.airport_data_container {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100px;\r\n    overflow: hidden;\r\n    border-radius: 15px 15px 0 0;\r\n}\r\n\r\n/* Wrapper for the image */\r\n.airport_data_image-wrap {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1; /* Behind text */\r\n    border-radius: 15px 15px 0 0;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Image with bottom alignment */\r\n.airport_data_image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center bottom;\r\n    filter: brightness(50%);\r\n    border-radius: 15px 15px 0 0;\r\n}\r\n\r\n/* Overlay using ::before */\r\n.airport_data_image-wrap::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 102, 204, .6); /* Blue overlay */\r\n    z-index: 2; /* Above the image, behind text */\r\n    border-radius: 15px 15px 0 0;\r\n}\r\n\r\n/* Text Content */\r\n.airport_data_text {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: white;\r\n    z-index: 3; /* Above overlay */\r\n    width: 80%;\r\n}\r\n\r\n.airport_data_text h1 {\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.airport_data_text p {\r\n    font-size: 1.2em;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n}\r\n\r\n/* Home Welcome Widget */\r\n.home_welcome_container {\r\n    position: relative;\r\n    color: white;\r\n    width: 100%;\r\n    height: 150px; /* Adjust based on how much text you have */\r\n    overflow: hidden; /* Ensures no overflow issues */\r\n}\r\n\r\n/* Create a wrapper for the image */\r\n.home_welcome_image-wrap {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1; /* Behind the text */\r\n}\r\n\r\n\r\n.home_welcome_container::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 3; /* Ensures it sits above the image */\r\n    background: linear-gradient(rgba(1, 30, 65, 0.3), rgba(8, 38, 71, 0.6));\r\n}\r\n\r\n.home_welcome_image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center bottom;\r\n    filter: brightness(50%);\r\n}\r\n\r\n.home_welcome_text {\r\n    position: absolute;\r\n    top: 0%;\r\n    left: 50%;\r\n    transform: translate(-50%, 0%);\r\n    width: 80%;\r\n    z-index: 3;\r\n}\r\n\r\n.home_welcome_text h1 {\r\n    color: white;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.home_welcome_text p {\r\n    color: white;\r\n    margin-bottom: 10px;\r\n    text-align: left; /* Align text to the left */\r\n    margin: 0; /* Remove auto-centering */\r\n    flex: 1; \r\n    font-weight: bold;\r\n}\r\n\r\n.home_welcome_text button {\r\n    all: unset;\r\n    color: #4c84ae; /* Yellow color */\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease-in-out;\r\n    display: inline-block; /* Ensures it stays next to the paragraph */\r\n    margin-left: 10px; /* Moves button next to text */\r\n    flex-shrink: 0;\r\n}\r\n\r\n.home_welcome_text button:hover {\r\n    color: white;\r\n}\r\n\r\n.home_welcome_text a {\r\n    all: unset;\r\n    color: #4c84ae; /* Yellow color */\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease-in-out;\r\n    display: inline-block; /* Ensures it stays next to the paragraph */\r\n    margin-left: 10px; /* Moves button next to text */\r\n    flex-shrink: 0;\r\n}\r\n\r\n.home_welcome_text a:hover {\r\n    color: white;\r\n}\r\n\r\n/* Tab Link Welcome*/\r\n#widget_tab_link_home_welcome button {\r\n    all: unset;\r\n    color: rgb(0, 102, 204);\r\n    text-decoration: none;\r\n    transition: 0.3s ease-in-out;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\n#widget_tab_link_home_welcome button:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n#widget_tab_link_home_welcome h1 {\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n/* Tab Link Flight Tracker*/\r\n#widget_tab_link_home_flight_link button {\r\n    all: unset;\r\n    color: rgb(0, 102, 204);\r\n    text-decoration: none;\r\n    transition: 0.3s ease-in-out;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\n#widget_tab_link_home_flight_link button:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n#widget_tab_link_home_flight_link h1 {\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n/* Tab Link Complaint*/\r\n#widget_tab_link_home_complaint {\r\n    background-color: rgb(44, 187, 174);\r\n    border-radius: 15px;\r\n    padding: 10px;\r\n}\r\n\r\n#widget_tab_link_home_complaint button {\r\n    padding: 3px 6px;\r\n    background-color: #fafafa;\r\n    color: #011E41;\r\n}\r\n\r\n#widget_tab_link_home_complaint button:hover {\r\n    background-color: rgb(1, 30, 65);\r\n    border-color: #257dfd;\r\n    color: #4c84ae;\r\n}\r\n\r\n#widget_tab_link_home_complaint h1 {\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n/* FAQ Widget */\r\n#widget_accordion_faq\r\n{\r\n    padding: 32px;\r\n    width: auto;\r\n}\r\n\r\n#widget_accordion_faq > div \r\n{\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n    color: white;\r\n    background-color:  rgb(1, 30, 65);\r\n    border: 1px solid black;\r\n}\r\n\r\n#widget_accordion_faq h2 \r\n{\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n#widget_accordion_faq > div > h3 > div\r\n{\r\n    color: white;\r\n    background-color:  rgb(1, 30, 65);\r\n}\r\n\r\n#widget_accordion_faq a {\r\n    all: unset;\r\n    color: #4c84ae; /* Yellow color */\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease-in-out;\r\n    display: inline-block; /* Ensures it stays next to the paragraph */\r\n    margin-left: 10px; /* Moves button next to text */\r\n    flex-shrink: 0;\r\n}\r\n\r\n#widget_accordion_faq a:hover {\r\n    color: white;\r\n}\r\n\r\n#widget_accordion_runways\r\n{\r\n    padding: 32px;\r\n    width: auto;\r\n}\r\n\r\n#widget_accordion_runways > div \r\n{\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n    color: white;\r\n    background-color:  rgb(1, 30, 65);\r\n    border: 1px solid black;\r\n}\r\n\r\n#widget_accordion_runways h2 \r\n{\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n/* Complaint Widget */\r\n#widget_complaint\r\n{\r\n    padding: 32px;\r\n}\r\n\r\n#widget_complaint > table\r\n{\r\n    padding: 5px;\r\n    background-color: gainsboro;\r\n    border: 1px solid black;\r\n    border-radius: 12px;\r\n}\r\n\r\n#widget_complaint > table > tbody > tr > td\r\n{\r\n    padding: 5px;\r\n}\r\n\r\n#textfield_first_name\r\n{\r\n    width: 150px;\r\n}\r\n\r\n#textfield_last_name\r\n{\r\n    width: 150px;\r\n}\r\n\r\n#textfield_city\r\n{\r\n    width: 150px;\r\n}\r\n\r\n#textfield_zip\r\n{\r\n    width: 100px;\r\n}\r\n\r\n#textfield_address\r\n{\r\n    width: 250px;\r\n}\r\n\r\n#textfield_description\r\n{\r\n    width: 450px;\r\n    height: 150px;\r\n}\r\n\r\n#button_save\r\n{\r\n    float: right;\r\n    width: 200px;\r\n}\r\n\r\n/* Mobile Complaint Widget */\r\n#widget_mobile_complaint\r\n{\r\n    padding: 16px;\r\n}\r\n\r\n#widget_mobile_complaint > table\r\n{\r\n    padding: 5px;\r\n    background-color: gainsboro;\r\n    border: 1px solid black;\r\n    border-radius: 12px;\r\n}\r\n\r\n#widget_mobile_complaint > table > tbody > tr > td > h3\r\n{\r\n    margin: 0px;\r\n}\r\n\r\n#widget_mobile_complaint > table > tbody > tr > td\r\n{\r\n    padding: 4px;\r\n}\r\n\r\n#portal_help h2\r\n{\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n#runway_config{\r\n    /*overflow: scroll !important;*/\r\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); \r\n    border-radius: 15px;\r\n}\r\n\r\n#runway_config h2\r\n{\r\n    text-align: center;\r\n    color: rgb(1, 30, 65);\r\n}\r\n\r\n#publicvue_pbi {\r\n    border-radius: 15px; \r\n    overflow: hidden;\r\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); \r\n}\r\n\r\n#graphs_1x {\r\n    border-radius: 0 0 15px 15px; \r\n    overflow: visible !important; \r\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);\r\n    color: white; \r\n}\r\n\r\n#graphs_1x h2{\r\n    color: white; \r\n}\r\n\r\n#graphs_2x {\r\n    border-radius: 0 0 15px 15px;  \r\n    overflow: visible !important; \r\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3); \r\n    color: white;\r\n}\r\n\r\n#graphs_2x h2{\r\n    color: white;\r\n}\r\n\r\n#graphs_3x {\r\n    border-radius: 0 0 15px 15px;  \r\n    overflow: visible !important; \r\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);\r\n    color: white; \r\n}\r\n\r\n#graphs_3x h2{\r\n    color: white; \r\n}\r\n\r\n.date-filter-container {\r\n    background-color: #002147;\r\n    border-radius: 4px;\r\n    padding-top: 20px;\r\n    max-width: 300px;\r\n    color: white;\r\n    font-family: inherit;\r\n  }\r\n  \r\n  .date-filter-label {\r\n    color: white;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .date-filter-input-label {\r\n    color: white !important;\r\n  }\r\n  \r\n  .date-filter-select {\r\n    color: white;\r\n  }\r\n  \r\n  .date-filter-select .MuiOutlinedInput-notchedOutline {\r\n    border-color: white;\r\n  }\r\n  \r\n  .date-filter-select.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n    border-color: #80bdff;\r\n  }\r\n  \r\n  .date-filter-select:hover .MuiOutlinedInput-notchedOutline {\r\n    border-color: #80bdff;\r\n  }\r\n  \r\n  .date-filter-select .MuiSvgIcon-root {\r\n    color: white;\r\n  }\r\n  \r\n  .date-filter-select .MuiSelect-select {\r\n    color: white;\r\n  }\r\n\r\n  \r\n  .date-filter-select .MuiOutlinedInput-notchedOutline {\r\n    border-color: white;\r\n  }\r\n\r\n  .slider-widget-filter-bar {\r\n    width: 100%;\r\n    background-color: #002147;\r\n    padding: 12px 40px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  @media screen and (max-width: 768px) {\r\n  .home_welcome_text h1 {\r\n        font-size: 28px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
